
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3333 2C6.33333 2 2 3.08333 2 5.33333C2 7.58333 6.33333 8.66667 10.3333 8.66667C14.3333 8.66667 18.6667 7.58333 18.6667 5.33333C18.6667 3.08333 14.3333 2 10.3333 2ZM2 8.33331C3.91667 9.74998 7.16667 10.3333 10.3333 10.3333C13.5 10.3333 16.75 9.74998 18.6667 8.33331V11.1044C18.2882 11.0358 17.8983 11 17.5 11C14.679 11 12.2778 12.797 11.3786 15.3088C11.0297 15.3252 10.6803 15.3333 10.3333 15.3333C6.33333 15.3333 2 14.25 2 12V8.33331ZM11.0197 16.9908C10.7908 16.997 10.5618 17 10.3333 17C7.16667 17 3.91667 16.4167 2 15V18.6667C2 20.9167 6.33333 22 10.3333 22C11.1185 22 11.9164 21.9583 12.692 21.8742C11.6408 20.7194 11 19.1845 11 17.5C11 17.3286 11.0066 17.1588 11.0197 16.9908Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16.625 15.875H20.375V16.625H16.625V18.5L14 16.25L16.625 14V15.875ZM20.3749 17.75L22.9999 20L20.3749 22.25V20.375H16.6249V19.625H20.3749V17.75Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowswichdataFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
